var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"lesson-bs-wrap"},[(_vm.unSigned || (!_vm.lessonInfo.hasMsPenScreenshot && !_vm.lessonInfo.hasMsPhoto))?_c('span',{staticClass:"lesson-bs-noclick"},[_vm._v(" 课堂相册 ")]):_c('span',{staticClass:"lesson-bs"},[_c('a',{on:{"click":_vm.handleBanshu}},[_vm._v("课堂相册")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }